import { useMemo } from 'react'

import { get } from 'lodash'
import { useSelector, useDispatch } from 'react-redux'
import { bindActionCreators } from 'redux'

import actionRoute from '~/modules/master/redux/actions/route'

const useRoute = () => {
  const data = useSelector((state) => get(state, 'master.route'))

  const dispatch = useDispatch()
  const actions = useMemo(
    () => bindActionCreators(actionRoute, dispatch),
    [dispatch],
  )
  return {
    actions,
    data,
  }
}

export default useRoute
